const Browser = () => (
  <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.83337" y="13.3334" width="50.6667" height="10.6667" rx="1" fill="#E69900" fillOpacity="0.6" />
    <rect x="5.83337" y="29.3334" width="50.6667" height="26.6667" rx="1" fill="#E69900" fillOpacity="0.2" />
  </svg>
)

export default Browser
